import FreemiumEventCreateDetailsStep from './FreemiumEventCreateDetailsStep';

export default FreemiumEventCreateDetailsStep;
